import React from "react";

import ReactJS from "../../../src/Assets/Skills/ReactJS.svg";
import NextJS from "../../../src/Assets/Skills/NextJS.svg";
import Cpp from "../../../src/Assets/Skills/Cpp.svg";
import HTML from "../../../src/Assets/Skills/HTML.svg";
import CSS from "../../../src/Assets/Skills/CSS.svg";
import Javascript from "../../../src/Assets/Skills/Javascript.svg";
import Figma from "../../../src/Assets/Skills/Figma.svg";
import AWS from "../../../src/Assets/Skills/AWS.svg";
import Firebase from "../../../src/Assets/Skills/Firebase.svg";
import Guitar from "../../../src/Assets/Skills/Guitar.svg";
import Bootstrap from "../../../src/Assets/Skills/Bootstrap.svg";
import MongoDB from "../../../src/Assets/Skills/MongoDB.svg";
import Github from "../../../src/Assets/Skills/Github.svg";
import Netlify from "../../../src/Assets/Skills/Netlify.svg";
import TailwindCss from "../../../src/Assets/Skills/TailwindCss.svg";
import C from "../../../src/Assets/Skills/C.svg";
import NodeJS from "../../../src/Assets/Skills/NodeJS.svg";
import ExpressJS from "../../../src/Assets/Skills/ExpressJS.svg";
import Git from "../../../src/Assets/Skills/Git.svg";
import Sass from "../../../src/Assets/Skills/Sass.svg";
import VSCode from "../../../src/Assets/Skills/VSCode.svg";
import Postman from "../../../src/Assets/Skills/Postman.svg";

export default function Skills() {
  return (
    <>
      <h2 className="text-center" style={{ color: "#50d890" }}>
        My Skills
      </h2>
      <br />
      <p className="text-center" style={{ color: "white" }}>
        These are the tools and technologies I already have experience working
        upon.
      </p>
      <br />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <br />
        <div className="skill_set">
          <div className="skill">
            <a href="https://reactjs.org/" target="_blank" rel="noreferrer">
              <img src={ReactJS} alt="ReactJS" />
            </a>
          </div>
          <div className="skill">
            <a href="https://nextjs.org/" target="_blank" rel="noreferrer">
              <img src={NextJS} alt="NextJS" />
            </a>
          </div>

          <div className="skill">
            <a
              href="https://www.nodejs.org"
              target="_blank"
              rel="noreferrer"
            >
              <img src={NodeJS} alt="NodeJS" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://expressjs.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={ExpressJS} alt="ExpressJS" />
            </a>
          </div>
          <div className="skill">
            <a href="https://www.mongodb.com/" target="_blank" rel="noreferrer">
              <img src={MongoDB} alt="MongoDB" />
            </a>
          </div>
          <div className="skill">
            <a href="https://cplusplus.com/" target="_blank" rel="noreferrer">
              <img src={Cpp} alt="Cpp" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://www.w3schools.com/html/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={HTML} alt="HTML" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://www.w3schools.com/css/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={CSS} alt="CSS" />
            </a>
          </div>

          <div className="skill">
            <a
              href="https://sass-lang.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Sass} alt="Sass" />
            </a>
          </div>

          <div className="skill">
            <a href="https://www.figma.com/" target="_blank" rel="noreferrer">
              <img src={Figma} alt="Figma" />
            </a>
          </div>
          <div className="skill">
            <a href="https://tailwindcss.com/" target="_blank" rel="noreferrer">
              <img src={TailwindCss} alt="TailwindCss" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://getbootstrap.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Bootstrap} alt="Bootstrap" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://firebase.google.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Firebase} alt="Firebase" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://aws.amazon.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={AWS} alt="Firebase" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Javascript} alt="Javascript" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://www.youtube.com/@viveksrivastava3072"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Guitar} alt="Guitar" />
            </a>
          </div>

          <div className="skill">
            <a
              href="https://git-scm.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Git} alt="Git" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://github.com/Vivek3072"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Github} alt="Github" />
            </a>
          </div>
          <div className="skill">
            <a href="https://www.postman.com/" target="_blank" rel="noreferrer">
              <img src={Postman} alt="Postman" />
            </a>
          </div>
          <div className="skill">
            <a href="https://code.visualstudio.com/" target="_blank" rel="noreferrer">
              <img src={VSCode} alt="VSCode" />
            </a>
          </div>
          <div className="skill">
            <a href="https://www.netlify.com/" target="_blank" rel="noreferrer">
              <img src={Netlify} alt="Netlify" />
            </a>
          </div>
          <div className="skill">
            <a
              href="https://www.cprogramming.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={C} alt="C" />
            </a>
          </div>
        </div>
        <br /> <br />
      </div>
    </>
  );
}
